import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const el = navRef.current;
    if (!el) return;

    const syncHeight = () => {
      const h = Math.ceil(el.getBoundingClientRect().height);
      document.documentElement.style.setProperty("--navbar-height", `${h}px`);
    };

    syncHeight();
    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(syncHeight);
      ro.observe(el);
    }
    window.addEventListener("resize", syncHeight);

    return () => {
      ro?.disconnect();
      window.removeEventListener("resize", syncHeight);
      document.documentElement.style.removeProperty("--navbar-height");
    };
  }, []);

  return (
    <nav className="navbar" ref={navRef}>

      <div className="navbar-container">

        {/* LOGO + NAME */}
        <Link to="/" className="navbar-logo">

          <div className="logo-circle">
            <img src="/og logo.jpeg" alt="logo" />
          </div>

          <span className="logo-text">Namo Digital Hub</span>

        </Link>

        {/* MENU */}
        <ul className={`navbar-menu ${menuOpen ? "active" : ""}`}>

          <li><Link to="/" className="navbar-link" onClick={() => setMenuOpen(false)}>Home</Link></li>

          <li><Link to="/about" className="navbar-link" onClick={() => setMenuOpen(false)}>About</Link></li>

          <li><Link to="/services" className="navbar-link" onClick={() => setMenuOpen(false)}>Services</Link></li>

          <li><Link to="/web-development" className="navbar-link" onClick={() => setMenuOpen(false)}>Web Dev</Link></li>

          <li><Link to="/contact" className="navbar-link" onClick={() => setMenuOpen(false)}>Contact</Link></li>

        </ul>

        {/* HAMBURGER */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>

    </nav>
  );
}

export default Navbar;